/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiGroupParams,
  GroupCreateUpdateDTO,
  GroupMoveRequest,
  GroupViewDTO,
  GroupViewDTOPaginationResult,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiGroup = (
    params?: GetApiGroupParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupViewDTOPaginationResult>(
      {url: `/api/Group`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiGroupInfiniteQueryKey = (params?: GetApiGroupParams,) => {
    return [
    'infinite', `/api/Group`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiGroupQueryKey = (params?: GetApiGroupParams,) => {
    return [
    `/api/Group`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiGroupInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiGroup>>>, TError = unknown>(params?: GetApiGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGroupInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGroup>>> = ({ signal }) => getApiGroup(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiGroupInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGroup>>>
export type GetApiGroupInfiniteQueryError = unknown


export function useGetApiGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroup>>>, TError = unknown>(
 params: undefined |  GetApiGroupParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroup>>,
          TError,
          Awaited<ReturnType<typeof getApiGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroup>>>, TError = unknown>(
 params?: GetApiGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroup>>,
          TError,
          Awaited<ReturnType<typeof getApiGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroup>>>, TError = unknown>(
 params?: GetApiGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroup>>>, TError = unknown>(
 params?: GetApiGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiGroupInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiGroupQueryOptions = <TData = Awaited<ReturnType<typeof getApiGroup>>, TError = unknown>(params?: GetApiGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGroupQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGroup>>> = ({ signal }) => getApiGroup(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGroup>>>
export type GetApiGroupQueryError = unknown


export function useGetApiGroup<TData = Awaited<ReturnType<typeof getApiGroup>>, TError = unknown>(
 params: undefined |  GetApiGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroup>>,
          TError,
          Awaited<ReturnType<typeof getApiGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroup<TData = Awaited<ReturnType<typeof getApiGroup>>, TError = unknown>(
 params?: GetApiGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroup>>,
          TError,
          Awaited<ReturnType<typeof getApiGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroup<TData = Awaited<ReturnType<typeof getApiGroup>>, TError = unknown>(
 params?: GetApiGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiGroup<TData = Awaited<ReturnType<typeof getApiGroup>>, TError = unknown>(
 params?: GetApiGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiGroupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiGroup = (
    groupCreateUpdateDTO?: GroupCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupViewDTO>(
      {url: `/api/Group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupCreateUpdateDTO, signal
    },
      options);
    }




export const getPostApiGroupMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGroup>>, TError,{data?: GroupCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGroup>>, TError,{data?: GroupCreateUpdateDTO}, TContext> => {

const mutationKey = ['postApiGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGroup>>, {data?: GroupCreateUpdateDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGroup>>>
    export type PostApiGroupMutationBody = GroupCreateUpdateDTO | undefined
    export type PostApiGroupMutationError = ProblemDetails

    export const usePostApiGroup = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGroup>>, TError,{data?: GroupCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiGroup>>,
        TError,
        {data?: GroupCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPostApiGroupMutationOptions(options), queryClient);
    }
    export const getApiGroupId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupViewDTO>(
      {url: `/api/Group/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiGroupIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Group/${id}`
    ] as const;
    }

export const getGetApiGroupIdQueryKey = (id: string,) => {
    return [
    `/api/Group/${id}`
    ] as const;
    }


export const getGetApiGroupIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiGroupId>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGroupIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGroupId>>> = ({ signal }) => getApiGroupId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiGroupIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGroupId>>>
export type GetApiGroupIdInfiniteQueryError = ProblemDetails


export function useGetApiGroupIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroupId>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroupId>>,
          TError,
          Awaited<ReturnType<typeof getApiGroupId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroupIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroupId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroupId>>,
          TError,
          Awaited<ReturnType<typeof getApiGroupId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroupIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroupId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiGroupIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiGroupId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiGroupIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiGroupIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiGroupId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGroupIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGroupId>>> = ({ signal }) => getApiGroupId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiGroupIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGroupId>>>
export type GetApiGroupIdQueryError = ProblemDetails


export function useGetApiGroupId<TData = Awaited<ReturnType<typeof getApiGroupId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroupId>>,
          TError,
          Awaited<ReturnType<typeof getApiGroupId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroupId<TData = Awaited<ReturnType<typeof getApiGroupId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiGroupId>>,
          TError,
          Awaited<ReturnType<typeof getApiGroupId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiGroupId<TData = Awaited<ReturnType<typeof getApiGroupId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiGroupId<TData = Awaited<ReturnType<typeof getApiGroupId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGroupId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiGroupIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiGroupId = (
    id: string,
    groupCreateUpdateDTO?: GroupCreateUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupViewDTO>(
      {url: `/api/Group/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: groupCreateUpdateDTO, signal
    },
      options);
    }




export const getPutApiGroupIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGroupId>>, TError,{id: string;data?: GroupCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiGroupId>>, TError,{id: string;data?: GroupCreateUpdateDTO}, TContext> => {

const mutationKey = ['putApiGroupId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGroupId>>, {id: string;data?: GroupCreateUpdateDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiGroupId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGroupId>>>
    export type PutApiGroupIdMutationBody = GroupCreateUpdateDTO | undefined
    export type PutApiGroupIdMutationError = ProblemDetails

    export const usePutApiGroupId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGroupId>>, TError,{id: string;data?: GroupCreateUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiGroupId>>,
        TError,
        {id: string;data?: GroupCreateUpdateDTO},
        TContext
      > => {
      return useMutation(getPutApiGroupIdMutationOptions(options), queryClient);
    }
    export const deleteApiGroupId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown | null>(
      {url: `/api/Group/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiGroupIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGroupId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiGroupId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiGroupId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiGroupId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiGroupId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiGroupId>>>

    export type DeleteApiGroupIdMutationError = ProblemDetails

    export const useDeleteApiGroupId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiGroupId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiGroupId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiGroupIdMutationOptions(options), queryClient);
    }
    export const postApiGroupIdMove = (
    id: string,
    groupMoveRequest?: GroupMoveRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GroupViewDTO>(
      {url: `/api/Group/${id}/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupMoveRequest, signal
    },
      options);
    }




export const getPostApiGroupIdMoveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGroupIdMove>>, TError,{id: string;data?: GroupMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiGroupIdMove>>, TError,{id: string;data?: GroupMoveRequest}, TContext> => {

const mutationKey = ['postApiGroupIdMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGroupIdMove>>, {id: string;data?: GroupMoveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiGroupIdMove(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiGroupIdMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGroupIdMove>>>
    export type PostApiGroupIdMoveMutationBody = GroupMoveRequest | undefined
    export type PostApiGroupIdMoveMutationError = ProblemDetails

    export const usePostApiGroupIdMove = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGroupIdMove>>, TError,{id: string;data?: GroupMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiGroupIdMove>>,
        TError,
        {id: string;data?: GroupMoveRequest},
        TContext
      > => {
      return useMutation(getPostApiGroupIdMoveMutationOptions(options), queryClient);
    }
